export default {
  views: {
    privacy: {
      lastUpdated: '最終更新日 2026年09月10日',
      companyName: 'リンクティビティ株式会社',
      title: 'プライバシーポリシー',
      personalInfoProtectionPolicy: '個人情報保護方針',
      personalInfoProtectionDescription:
        '当社は、当社の運営する予約サイトLINKTIVITY等において、お客様から個人情報を取得しております。当社は、お客様が安心かつ便利に予約ができるようにするために、お客様の個人情報を保護することは非常に重要なことであると考えており、以下に記載する事項を遵守して個人情報を取り扱っております',
      customerDataManager: 'お客様の個人データの管理者',
      companyAddress:
        '〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F',
      acquisition: '取得の場面',
      acquisitionDescription:
        '当社は、法令により必要とされる場合にはお客様から同意を得た上で、当社の利用目的の達成に必要最低限の個人情報を取得します。',
      usage: '利用の場面',
      usageDescription:
        '当社は、当社の定める利用目的の達成のためにのみ、お客様から取得した個人情報を利用いたします。',
      storage: '保管・保存の場面',
      storageDescription:
        '当社は、お客様から取得した個人情報が外部に漏洩することのないよう、システムセキュリティに留意して個人情報の保管・保存等を行っています。',
      destruction: '破棄・消去の場面',
      destructionDescription:
        '当社は、利用する必要がなくなった個人データ（個人情報の保護に関する法律に定める個人データを意味します。以下同じです。）は、必要がなくなった時点で、遅滞なく破棄します。',
      customerInquiry: 'お客様からのお問い合わせ等への対応',
      customerInquiryDescription:
        '当社は、お客様からの保有個人データ（個人情報の保護に関する法律に定める保有個人データを意味します。以下同じです。）の利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求及び第三者提供の停止請求に対し、法令に従い対応いたします。',
      safetyMeasures: '安全管理措置等',
      safetyMeasuresDescription:
        '当社は、LINKTIVITYサービスに関係する全てのスタッフが、個人情報の重要性を理解できるよう教育を行うほか、個人情報の安全管理のために必要かつ適切な措置を講じています。',
      tableOfContents: '目次',
      policy1: {
        title: '当社が取得する個人情報と利用目的について',
        description:
          '当社は、以下に掲げる利用目的で、お客様のご住所、ご氏名、生年月日、ご連絡先、メールアドレス又は旅券番号等の個人情報を取得し、利用いたします。また、当社は、お客様の同意なく要配慮個人情報を取得いたしません。なお、お客様の個人情報の取得にあたり、個人情報の利用目的が公表されていない場合には、かかる取得の対象となった個人情報の利用目的を、お客様に通知し、又は公表するものとします。また、当社は、保護者の同意なく13歳以下の児童から個人情報を取得しません。13歳以下の児童の個人情報を提供いただく場合、保護者の同意を取得いただいているものとして取り扱いますが、同意がないことが明らかになった場合には、保護者への連絡その他これに付随する目的以外に当該個人情報を利用しません。',
        serviceUsage: {
          title: 'LINKTIVITYサービス利用（会員登録等）のため',
          description:
            'LINKTIVITYサービス利用のため、お客様の個人情報を当社内部で共有します。',
          legalBasis:
            'お客様の要求するサービスや機能を提供するために必要となります。'
        },
        ticketPurchase: {
          title: 'チケット購入のお申込みのため',
          infoItems:
            '当社は、お客様からの商品提供者からのチケット購入の申込み等に際して、お客様のご氏名や、決済情報、旅券番号のほか、健康状態や病歴等といったお客様の健康状態に関する情報等を取得いたします。',
          purpose:
            '当社は、お客様の商品提供者からのチケット購入資格の確認やチケットの代金等の決済のためにお客様の個人情報を取得し、利用いたします。また、かかる目的のために、商品提供者、交通機関、代金決済事業者等（海外の事業者等を含みます。）へお客様の個人情報を提供いたします。',
          legalBasis:
            'お客様の要求するサービスや機能を提供するために必要となります。'
        },
        newsletter: {
          title:
            'ニュースレター（メールマガジン等）の送付等、お客様へのご案内の送付のため',
          legalBasis: 'お客様からの同意に基づき収集します。'
        },
        advertising: {
          title:
            'ソーシャルメディアや広告配信プラットフォームを通じた広告のため',
          legalBasis: 'お客様からの同意に基づき収集します。'
        },
        survey: {
          title: 'アンケートへのご記入のお願いのため',
          legalBasis:
            '当社の予約サイト、商品やサービス等の改善のためお客様の同意に基づき収集します。'
        },
        analysis: {
          title: 'お客様情報の解析及び管理のため',
          legalBasis:
            '当社の予約サイト、商品やサービス等の改善することにより、お客様の正当な利益を追求・保護するために必要となります。'
        },
        fraudDetection: {
          title: 'クレジットカード等の不正利用の検知及び防止のため',
          description1:
            '当社は、チケット予約サービス及び会員登録サービスにおける不正購入、不正転売、なりすまし、不正決済、チャージバックその他の不正行為の検知及び防止並びにサービスの安全性向上を目的として、以下の情報を取得し利用する場合があります。提供先には、Forter Inc.その他当社が別途公表する不正利用防止サービス提供事業者が含まれます。',
          description2:
            '当社が提供する情報には、氏名、生年月日、メールアドレス、電話番号、住所、予約情報、購入履歴、決済関連情報、IPアドレス、Cookie情報、ブラウザ情報、端末情報、アクセスログその他不正利用防止のために必要な情報が含まれる場合があります。',
          description3:
            '提供先は、これらの情報を分析し、取引に係るリスク評価、不正利用の判定、本人確認支援その他の不正利用防止サービスを提供します。',
          description4:
            '当社は、当該事業者から提供される分析結果及び判定結果を、予約受付、会員登録、本人確認、決済処理、不正利用防止及びサービス運営のために利用し、取引の承認、保留又は追加確認の要否を判断する場合があります。',
          legalBasis:
            '不正利用防止及びクレジットカード等の不正決済防止により、当社ならびにお客様の正当な利益を追求するために必要となります。'
        }
      },
      policy2: {
        title: '個人データの第三者提供について',
        description:
          '当社は、以下のいずれかの場合を除き、お客様から取得した個人データを第三者に提供いたしません。',
        case1:
          'お客様から第三者（商品提供者、海外の旅行業者、ソーシャルメディア事業者、広告配信サービス会社等の事業者を含みます。）への個人データの提供について、本プライバシーポリシーに同意いただく方法その他の方法により、事前にご同意をいただいた場合',
        case2:
          '上記の利用目的の達成に必要な範囲内において個人データの取扱を外部委託した場合',
        case3: '法令に基づき提供を求められた場合',
        case4:
          '人の生命、身体又は財産の保護のために必要な場合であって、お客様の同意を得ることが困難である場合',
        case5:
          '公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難である場合',
        case6:
          '国又は地方公共団体などが法令に定める事務を実施する上で、協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合'
      },
      policy3: {
        title: '外国にある第三者への個人データの提供について',
        description1:
          '前条に定める場合として、当社は、本サービスにおける不正取引の検知及び防止を目的に、お客様の個人データを外国に所在する第三者へ提供する場合があります。',
        description2:
          '当社は、個人情報保護法その他関係法令に従い、外国にある第三者への個人データの提供に関して必要な情報をお客様へ提供した上で、お客様の同意を取得し、又はその他適法な方法に基づいて当該提供を行います。',
        description3:
          '当社は、提供先の所在国の個人情報保護制度に関する情報、当該第三者が講ずる個人情報保護措置その他法令上提供が求められる情報について、当社ウェブサイトへの掲載その他当社が適当と認める方法により公表又は提供します。',
        description4:
          '本サービスにおける、不正取引の検知及び防止を目的としてお客様から取得し、外国に所在する第三者へ提供するデータの項目等の詳細については下記の通りとなります。',
        item1Label: '（１）提供する個人データの項目',
        item1Content:
          'オンライン取引情報（ユーザーID、会員番号、氏名、電子メールアドレス、電話番号、住所等）、デバイス情報（OSの種類、言語、IPアドレス、ブラウザの種類、位置情報、端末識別番号等）',
        item2Label: '（２）提供の手段又は方法',
        item2Content:
          '電子的方法（オンライン取引情報はハッシュ化し、可読できない状態で送信します。）',
        item3Label: '（３）不正検知サービス事業者及び所在する外国の名称等',
        companyNameLabel: '事業者名：',
        companyName: 'Forter, Inc.',
        countryLabel: '所在国：',
        country: 'United States',
        addressLabel: '住所：',
        address: '575 5th Avenue, New York, United States (10017)',
        representativeLabel: '代表者：',
        representative: 'Michael Reitblat',
        item4Label: '（４）外国における個人情報の保護に関する制度に関する情報',
        item4Content: '以下の個人情報保護委員会のサイトよりご確認ください。',
        item5Label:
          '（５）不正検知サービス運営事業者が講ずる個人情報保護の措置',
        item5Content:
          '下記のForter社ウェブページ（プライバシーポリシー等）よりご確認ください。',
        description5:
          'お客様が会員登録又はチケット購入の際に、本プライバシーポリシーに同意した場合には、本項に定める外国にある第三者への個人データの提供についてもあわせて同意いただいたものとして取り扱う場合があります。'
      },
      policy4: {
        title: '個人データの取扱の委託について',
        description:
          '当社は、前項に基づき当社の利用目的の達成に必要な範囲内で第三者にお客様の個人データの取扱いを委託する場合、委託先に対して必要かつ適切な監督を行います。また、委託先が再委託を行う場合には、当社は、委託先が再委託先に対して、必要かつ適切な監督を行っているか否かを直接又は間接に監督いたします。再委託先が再々委託する場合についても同様とします。'
      },
      policy5: {
        title: 'Cookie情報等の取得について',
        cookie: {
          title: 'クッキー（Cookie）',
          description1:
            '当社は、セッションクッキーその他のCookieを利用する場合があります。クッキーとは、お客様（ユーザー）についての情報を含む、ユーザーのハードドライブに蓄えられるデータのひとつです。当社では、クッキーを、個人を特定する情報として利用することはありません。また、セッションクッキーについては、ブラウザを閉じると削除されます。',
          description2:
            'クッキーは、お客様へのサービス向上、当社サイトのカスタマイズ・広告の効果の測定等の目的で利用します。',
          description3:
            'また、当社は、統計処理データとしてクッキーを分析することによって、お客様のご興味やご関心の高い事項を探知し、それらを活用しているほか、不正アクセス防止のためにも利用しております。',
          description4:
            'クッキーは、お客様のご希望に応じて無効化することができますが、それにより、お客様はLINKTIVITYでのご予約ができなくなります。また、当社は、不正利用防止及び取引リスク評価を目的として、Cookie、デバイス識別子その他これに類する情報を取得し、不正利用防止サービス提供事業者へ提供する場合があります。'
        },
        logFile: {
          title: 'ログ・ファイル',
          description1:
            '当社では、特定の情報を自動的に収集してログ・ファイルに保存しています。この特定の情報には、IP（インターネットプロトコル）アドレス、ブラウザの種類、ISP（インターネットサービスプロバイダ）、参照/終了ページ、オペレーティングシステム、日付/タイムスタンプが含まれます。当社は、これらの情報を、不正アクセスを監視する目的で利用しております。また、当社は、お客様の傾向分析や、サイト管理、サイトにおけるお客様の動向追跡を行っています。',
          description2:
            'ただし、当社は、これらの情報を、特定の個人を識別できないようにして利用しており、取得した情報を上記以外の目的で利用することはありません。当社は、不正利用防止及びセキュリティ向上のため、IPアドレス、ブラウザ情報、端末識別情報、アクセスログその他のオンライン識別情報を取得し、不正利用防止サービス提供事業者へ提供する場合があります。'
        },
        webBeacon: {
          title: 'ウェブビーコンについて',
          description:
            '当社では、ウェブビーコンを、アクセス解析及びアフィリエイトプログラムのために利用しています。当社は、ウェブビーコンについて、上記以外の目的での利用や、特定の個人を識別するための利用はしておりません。'
        },
        statisticalAnalysis: {
          title: '統計的分析について',
          description1:
            '当社では、どのサイトやサービスの人気が高いかを確認するために、第三者アクセス解析ツールを利用し、LINKTIVITYサイト内でお客様がアクセスしたページや、ページの履歴を記録しています。',
          description2:
            '当社は、これらのデータを、特定の分野にご興味を示されたお客様に対して、LINKTIVITY内で、その興味に合わせたコンテンツや広告を提供するために使用しています。',
          description3:
            'また、個人を特定しない統計情報を収集することもあります。さらに、第三者アクセス解析ツール上にて当社が収集したクッキー情報と他社が収集したクッキー情報を双方で閲覧可能にすることもあります。'
        }
      },
      policy6: {
        title: '匿名加工情報の取扱いついて',
        creation: {
          title: '匿名加工情報の作成',
          description1:
            '当社は、匿名加工情報を作成する場合には、以下の対応を行います。匿名加工情報とは、法令の定めによる措置を講じて特定の個人を識別することができないように個人情報を加工して得られる個人に関する情報であって、当該個人情報を復元することができないようにしたものをいいます。',
          description2:
            '①法令で定める基準に従い、適正に加工すること ②法令で定める基準に従い、削除した情報や加工の方法に関する情報の漏えいを防止するために安全管理措置を講じること③作成した匿名加工情報に含まれる情報の項目を公表すること④作成に用いられた個人情報に係る本人を識別するための行為をしないこと'
        },
        provision: {
          title: '匿名加工情報の提供',
          description:
            '匿名加工情報を第三者に提供する場合には、提供しようとする匿名加工情報に含まれる個人に関する情報の項目と提供の方法を公表するとともに、提供先となる第三者に対して、提供する情報が匿名加工情報であることを明示します。'
        },
        disclosure: {
          title: '匿名加工情報に関する公表',
          creationSubtitle: '匿名加工情報の作成について',
          creationDescription:
            '当社が保有する以下のお客様の個人情報について、当社は、特定の個人を識別すること及び個人情報を復元することができないよう適切な措置を講じたうえで匿名加工情報として継続的に作成いたします。',
          itemsTitle: '匿名加工情報に含まれる個人に関する情報の項目',
          itemsDescription:
            'プラットフォームサービスの提供に関して取得した情報購入日、参加日、バウチャーの言語、販売金額のレンジ、参加人数、予約の状態（予約確定かキャンセル等）、サプライヤーの所在地域及び県情報、旅行会社の所在国',
          thirdPartyTitle: '匿名加工情報の第三者提供について',
          thirdPartyDescription:
            '当社が作成または保有する匿名加工情報について、当該情報が匿名加工情報であることを明示したうえで、継続的に第三者に提供いたします。',
          provisionMethod:
            'パスワードにより保護された電子ファイルを電子的な通信手段（電子メール、サーバーにアップロード、API連携等）、またはDVD等の物理媒体により送付'
        }
      },
      policy7: {
        title: '個人データの安全管理措置について',
        description1:
          '個人データの漏えい、盗用、悪用、不正アクセス、改ざん及び破壊等を防ぐために、組織的、技術的、物理的な安全管理措置を講じています。当社が個人データを保存するサーバーへのアクセスは、ID／PWを有する特定の従業員のみに制限されており、中でも一部の個人データの管理については、データの管理等に必要最小限の従業員にのみアクセスを付与しています。',
        description2:
          '更にクレジットカード情報を含む個人データについては、複数のデータセンターに分散してセキュアな環境において保管しています。また、当社は、予約取引に関するすべてのページでSecure Sockets Layer（SSL）暗号を使用しています。SSL対応ブラウザの使用により、インターネット上で送信する個人データとクレジットカード情報の機密性を保持することができます。',
        description3:
          'また、お客様の個人データを取り扱う当社の従業員は、端末を離れるときにはパスワードで保護されたスクリーンセーバーを使用しております。',
        description4:
          'さらに､当社は、部署によっては毎月1回、全社的には半年に1回以上の頻度で、個人情報の重要性等に関する教育研修を実施しております。また、教育に関する記録もとっております。'
      },
      policy8: {
        title: 'お客様の個人データの取扱いに関する権利について',
        description:
          '2016年4月27日付のEU一般データ保護規則（GDPR）2016/679に基づき、個人データの処理に関し、お客様は以下の権利があります。',
        right1: 'アクセス権',
        right2: '訂正権',
        right3: '削除権（忘れられる権利）と処理を制限する権利',
        right4: 'データポータビリティー権',
        right5: '異議を述べる権利',
        right6: 'プロファイリングを含む自動処理に基づく決定に服されない権利。'
      },
      policy9: {
        title: '開示・訂正・利用停止等の請求等について',
        description1:
          '当社は、お客様からの保有個人データの利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求又は第三者提供の停止請求（以下、総称して「開示等の請求等」といいます。）に対しては、下記12記載の連絡窓口にて対応いたします。',
        description2:
          'また、当社は、お客様のマイページにおいて、会員情報の変更及び確認並びにメールマガジンの配信停止等のご希望に応じることとしております。'
      },
      policy10: {
        title: '外部へのリンクについて',
        description:
          'LINKTIVITYホームページには、他のサイトへのリンクが含まれています。本プライバシーポリシーは、LINKTIVITYホームページによって収集される情報だけに適用され、その他のウェブサイトのプライバシーポリシーまたはコンテンツについて、当社は責任を負いません。お客様におかれましては、リンク先の各ウェブサイトで、プライバシーポリシーをお読みいただき、お客様の個人情報の取扱いについてご確認いただきますようお願い申し上げます。'
      },
      policy11: {
        title: 'プライバシーポリシーの変更について',
        description:
          '当社は、プライバシーポリシーをLINKTIVITYホームページ上に掲載し、当社がお客様のどのような個人情報をどのような目的で取得し、利用しているか、お客様が常に知ることができる状態にしています。また、プライバシーポリシーの変更についても、LINKTIVITYホームページ上に掲載し、お客様に公表しております。'
      },
      policy12: {
        title: '連絡先について',
        description1:
          '当社のプライバシーポリシーや、当社の個人情報保護への取り組み、お客様の個人情報の取得、利用等に関するご質問又は開示等の請求等については、下記のお問い合わせフォームをご利用ください。担当者より5営業日以内に返答させていただきます。',
        company: 'リンクティビティ株式会社',
        address:
          '〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F',
        dpoContact: 'データ保護責任者の連絡先 dpo@linktivity.co.jp'
      },
      contentLabels: {
        acquisitionOfPersonalInfo: '取得する個人情報の項目',
        specificPurpose: '具体的な利用目的',
        legalBasis: '法的根拠：',
        provisionMethod: '提供の方法'
      }
    },
    product: {
      plans: {
        title: 'プランを選択'
      },
      cancelPolicy: {
        title: 'キャンセルポリシー'
      },
      recommendations: {
        title: '他のおすすめ'
      },
      payment: {
        plan: 'プラン',
        dateTime: '日時',
        numberOfPeople: '人数',
        totalWithTax: '合計 (税込)',
        viewPlan: 'プランを見る',
        warn: '{{unitName}}のみの購入はできません'
      },
      panels: {
        selectDate: '日付を選択',
        selectPlan: 'プランを選択',
        selectPeople: '人数を選択',
        options: 'オプション',
        profile: 'プロフィール'
      },
      auth: {
        loginOrRegister: 'ログイン / 新規登録'
      }
    },
    book: {
      title: '予約確認',
      bookingNotice: 'ご予約前にご確認ください',
      paymentConfirmation: 'お支払い前にご確認ください',
      tip: 'ご注文を確定するには、15分以内に手続きを完了してください',
      sessionInfo: '注文情報'
    },
    bookConfirm: {
      productInfo: '商品情報',
      sessionConfirmed: '確認済',
      sessionUnconfirmed: '未確認',
      paymentInfo: '支払い情報',
      paymentConfirmation: {
        warningTitle: 'キャンセルポリシーを確認してください：',
        warningText: '一度購入した商品は返金できません。',
        agreementText: '内容を確認し、同意しました'
      },
      prePaymentConfirmation: {
        title: 'お支払前の確認事項',
        checkInput: '入力内容に間違いないかご確認ください。',
        emailNotice:
          'ご注意：迷惑メール対策でドメイン指定受信設定をされている場合は、予約前に「@linktivity.co.jp」ドメインの登録をお願いします。',
        agreementText: '上記事項を確認の上、同意しました'
      },
      paymentAmount: {
        total: '支払い金額（税込）',
        details: '詳細',
        note: 'JPY以外の通貨で表示される金額は現在の為替レートに基づく推定値であり、実際の請求額とわずかに異なる場合があります。参考までにご確認ください。'
      },
      confirmPaymentDialogTitle: '支払い確認',
      participantInfo: {
        title: '参加者情報',
        dialogTitle: '参加者情報を変更',
        change: '変更',
        password: 'パスワード',
        validation: {
          passwordRequired: 'パスワードを入力してください'
        }
      },
      couponApplied: 'クーポンを適用しました',
      couponFailed: 'クーポンは利用不可',
      couponRemoved: 'クーポンが削除されました',
      couponRemoveFailed: 'クーポンの削除に失敗しました',
      actionButtons: {
        back: '前へ',
        toPayment: '支払いへ'
      }
    },
    voucher: {
      pdf: '印刷用PDF',
      html: 'バウチャーを表示'
    },
    bookingDetail: {
      title: '予約情報',
      detailInfo: '予約詳細',
      startDate: '参加日時',
      validityPeriod: '有効期限',
      voucherInfo: 'バウチャー情報',
      digitalTicket: '電子チケット',
      invoice: 'レシート・領収書',
      invoiceSend: '発行',
      invoiceSent: '領収書発行済み',
      redemption: 'Eチケットを利用',
      meetingPoint: '入場場所のご案内',
      beforeTrip: 'ご利用前の確認事項',
      bookingAction: 'キャンセル',
      cancelBooking: '予約をキャンセル',
      cancelConfirmPolicy: 'キャンセルポリシーを確認してください：',
      customerName: '予約者名',
      actualPayment: '支払額',
      refundAmount: '払い戻し金額',
      orderId: '予約ID',
      orderCompletionTime: '購入日時',
      digitalTicketValidPeriod: 'QRコードは当日のみ有効です',
      digitalTicketWaiting: '*注文確認後、電子チケットがここに表示されます',
      sending: '送信中...',
      sendToEmail: 'メールで再送信',
      cancelConfirm: '予約をキャンセルします。よろしいですか？',
      cancelFee: 'キャンセル料金',
      cancelRemarkSelect: 'キャンセル理由を選択してください',
      inclusion: '含まれるもの',
      checklist: '注意事項',
      restrictions: '参加制限',
      requirements: '参加前・参加時必要事項',
      attireItems: '参加時必要な服装・持ち物',
      otherInfo: '備考・その他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'イメージ'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: 'その他',
      CANCEL_REASON_MODIFY_BOOKING: '予約内容を変更したいため',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '誤って予約したため',
      CANCEL_REASON_DUPLICATE_BOOKING: '重複して予約してしまったため',
      CANCEL_REASON_HEALTH_CONDITION: '体調不良のため',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '交通機関の遅延・運休のため',
      CANCEL_REASON_SCHEDULE_CONFLICT: '都合が合わなくなったため',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '他施設に変更するため'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'SHIBUYA SKY',
      header: {
        alt: 'SHIBUYA SKY'
      },
      search: {
        placeholder: '商品を検索'
      },
      ticketList: {
        title: 'チケット一覧'
      },
      enjoyPack: {
        title: 'エンジョイパック'
      }
    },
    faq: {
      tips: `本FAQに記載の内容（オンライン購入・キャンセル・領収書の発行等）に関するお問い合わせは、LINKTIVITY（リンクティビティ）カスタマーサポートまでご連絡ください。
SHIBUYA SKYの施設・サービス等に関するお問い合わせは、SHIBUYA SKY公式サイトのお問い合わせページよりお問い合わせください。
https://www.shibuya-scramble-square.com/sky/contact/

LINKTIVITY（リンクティビティ）カスタマーサポート
メール：<a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
オンライン購入に関するお問い合わせ電話番号：<a href="tel:03-6821-7193">03-6821-7193</a>
※お電話でお問い合わせいただいた場合、自動音声ガイダンスにてご案内します。その後、お問い合わせ内容に応じてオペレーターへお繋ぎします。
※お電話でのお問い合わせには、通話料が発生します。
オペレーター対応時間：10:00～19:00`
    }
  }
};
